<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import { Icon } from '@shared/ui/icon';

  export let search: string;
  export let url: string;

  const dispatcher = createEventDispatcher<{ navigate: void }>();
</script>

<section
  class="bg-default-50/80 dark:bg-default-700/60 dark:text-default-50/50 dark:border-t-dark-400 border-t-default-300 flex items-center gap-3 rounded-lg rounded-t-none border-t-[1px] p-3 px-5 py-2.5 text-base backdrop-blur-2xl md:px-4"
>
  <p class="flex items-center gap-2 py-2">
    See full result for

    <a
      href="{url}?search={search}"
      class="text-default-900 dark:text-default-50 group flex items-center gap-0.5"
      on:click="{() => dispatcher('navigate')}"
    >
      <span class="underline-group-hover underline-static">
        {search}
      </span>

      <Icon
        name="caretDown"
        classes="-rotate-90 w-4 h-4 mt-0.5 transition-transform duration-300 group-hover:translate-x-0.5"
      />
    </a>
  </p>
</section>

<style lang="scss">
  .underline-static:is(.dark *)::after {
    background-color: #fff;
    opacity: 0.25;
  }
</style>
